<template>
    <div>
        <h3>请先选择病种</h3>
        <div class="dislist">
          <div class="disitem" v-for="(item,index) in dislist" @click="godiscont(item.link)">
            <img :src="item.imgsrc">
            <p>{{item.title}}</p>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dislist:[
                  {
                    title:'胃肿瘤',
                    imgsrc:'https://images.dayiketang.com/weizl@3x.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=7&sn=d9c5414c34d3143c96e8b65431f43e52'
                  },{
                    title:'肺肿瘤',
                    imgsrc:'https://images.dayiketang.com/feizl@3x.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=4&sn=67506352bd4567b1adb562a75cd1be8a'
                  },{
                    title:'肝肿瘤',
                    imgsrc:'https://images.dayiketang.com/ganzl@3x.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=6&sn=e943b5b1ceb68287ef8b222f4490656c'
                  },{
                    title:'胰腺癌',
                    imgsrc:'https://images.dayiketang.com/yixianaizl@3x.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=12&sn=f6ea3e85f5076582cad67e8d8bed8e8c'
                  },{
                    title:'淋巴肿瘤',
                    imgsrc:'https://images.dayiketang.com/linbazhongliu.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=15&sn=7241be7fa8782cc3cd073b4593f8177b'
                  },{
                    title:'妇科肿瘤',
                    imgsrc:'https://images.dayiketang.com/fukezhongliu.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=14&sn=afc75d848b910e36900fd2786d154df4'
                  },{
                    title:'结直肠肿瘤',
                    imgsrc:'https://images.dayiketang.com/jiezhichangzl@3x.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=8&sn=825d49354837381bd2d3d62cdf5f4d95'
                  },{
                    title:'食管肿瘤',
                    imgsrc:'https://images.dayiketang.com/shiguanzl@3x.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=9&sn=d8cd81abfe0b24ba0f9b04ebc7863846'
                  },{
                    title:'甲状腺肿瘤',
                    imgsrc:'https://images.dayiketang.com/jiazhuangxianzl@3x.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=10&sn=2ed85b013b145e04bc11524ebaa0e736'
                  },{
                    title:'脑部肿瘤',
                    imgsrc:'https://images.dayiketang.com/naozhongliu.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=11&sn=ad2762c2e5378a929833b89e9b934834'
                  },{
                    title:'前列腺肿瘤',
                    imgsrc:'https://images.dayiketang.com/qlxzhongliu.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=13&sn=3bfb5aa1de1b9944c4ccfaf728de3cda'
                  },{
                    title:'其他肿瘤',
                    imgsrc:'https://images.dayiketang.com/qitazhongliu.png',
                    link:'https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDQyNjIwOQ==&hid=16&sn=9d2be4abb59e40b71c32036f6fa00a69'
                  }
                  ]
            }
        },
        onLoad() {

        },
        computed: {
            user_search_data() {

            }
        },
        components: {},
        methods: {
          godiscont(url){
            window.location.href = url
          }
        }
    }
</script>

<style scoped>
  *{
    box-sizing: border-box;
  }
  h3{
    font-size: 0.9rem;
    height: 1.2rem;
    margin-top: 1.15rem;
    margin-bottom: 0.4rem;
    padding-left: 0.8rem;
  }
  .disitem{
    width: 5.5rem;
    height: 4.75rem;
    margin-bottom: 0.55rem;
    text-align: center;
    font-size: 0.9rem;
    padding-top: 1rem;
  }
  .disitem img{
    width: 2rem;
    height: 2rem;
    margin-bottom: 0.2rem;
  }
  .dislist{
    display: flex;
    padding:0 2.7rem;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/pages/dislistpage/dislistpage.vue